import EmailScheduleFilterCard from "./EmailScheduleFilterCard";

export default EmailScheduleFilterCard;
